import React, { useEffect, useState } from 'react';
import { getUser } from '../../../service/UserService';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import UserOverview from './UserOverview/UserOverview';
import './../SidePanelTabs.css';

export default function UserTabs(props) {
    const overviewTab = "overview";
    const [activeTab, setActiveTab] = useState("");
    const [user, setUser ] = useState({});

    useEffect(() => {
        if (props?.uuid) {
            getUser(props.uuid, props.companyNumber, (result) => {
                setUser(result);
                setActiveTab(overviewTab);
            });
        }
    }, [props.uuid, props.companyNumber]);

    function handleTabSelection(tab) {
        // Avoid excess reassignment
        if (tab !== activeTab) {
            setActiveTab(tab);
        }
    }

    function retrieveContent() {
        switch (activeTab) {
            case overviewTab:
                return (<UserOverview user={user} companyNumber={props.companyNumber} />);
            default:
                return (<LoadingSpinner blue data-testid="efup-tabs-loading-spinner" />);
        }
    }

    return (
        <React.Fragment>
            <div className="efup-tab-component" data-testid="efup-tabs-component">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === overviewTab ? "active" : ""}`}
                            id="overview-tab"
                            type="button"
                            onClick={() => handleTabSelection(overviewTab)}
                            data-testid="efup-overview-tab"
                        >
                            Overview
                        </button>
                    </li>
                </ul>
            </div>
            <div className="offcanvas-body">
                <div className="d-lg-block">
                    <div className="tab-content" id="myTabContent">
                        {retrieveContent()}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}